<div class="ayudaSection" *ngIf="modo==='normal'">
  <section>
    <div class="menus noselect">
      <div class="menu" *ngFor="let menu of menus" [@openClose]="menu.activa  ? 'open' : 'closed'"
        (click)="selecionarmenu(menu)" onclick="window.scrollTo(0,0)"> {{menu.nombre}} </div>
    </div>
  </section>
  <div *ngIf="menuselex.nombre==='Preguntas frecuentes'">
    <section>
      <div class="tutorialesAyuda">
        <mmax-tutoriales></mmax-tutoriales>
      </div>
    </section>
    <section>
      <div class="ayudas">
        <div class="subayudacat noselect">
          Compras
        </div>

        <div class="unacateg noselect">
          <div class="texdeunacat">
            ¿Cómo hago una compra online? Elegí tus productos, agregalos al carrito y seguí los pasos del checkout: iniciá sesión o continuá como invitado, seleccioná si querés retirar en sucursal o recibir tu pedido por envío, elegí el medio de pago y confirmá. Te vamos a enviar un email con el resumen de tu compra.
          </div>
        </div>

        <div class="unacateg noselect">
          <div class="texdeunacat">
            ¿Necesito una cuenta para comprar? Podés navegar el catálogo y ver los precios sin iniciar sesión. Para finalizar una compra vas a necesitar iniciar sesión o crear una cuenta, ya sea con tu email o con tu cuenta de Google.
          </div>
        </div>

        <div class="unacateg noselect">
          <div class="texdeunacat">
            ¿Puedo modificar o cancelar un pedido ya confirmado? Comunicate con nosotros lo antes posible al {{telefonoAtencionAlCliente}} o por WhatsApp para que podamos gestionar el cambio antes de que el pedido sea despachado.
          </div>
        </div>

        <div class="subayudacat noselect">
          Retiro y envíos
        </div>

        <div class="unacateg noselect">
          <div class="texdeunacat">
            ¿Cómo funciona el retiro en sucursal? Al finalizar la compra podés elegir la sucursal más cercana según tu ubicación en el mapa. Cuando el pedido esté listo te avisamos por email para que pases a buscarlo con tu DNI y el número de pedido. El retiro no tiene costo adicional.
          </div>
        </div>

        <div class="unacateg noselect">
          <div class="texdeunacat">
            ¿A qué zonas hacen envíos? Realizamos envíos a los destinos habilitados que podés seleccionar al finalizar la compra. También contamos con envío express, disponible hasta las 17:00 hs; los pedidos realizados después de ese horario se despachan con prioridad al día siguiente.
          </div>
        </div>

        <div class="subayudacat noselect">
          Pagos
        </div>

        <div class="unacateg noselect">
          <div class="texdeunacat">
            ¿Qué medios de pago aceptan? Podés pagar con tarjetas de crédito y débito, y otros medios disponibles a través de Mercado Pago, de forma segura al finalizar tu compra.
          </div>
        </div>

        <div class="unacateg noselect">
          <div class="texdeunacat">
            ¿Qué pasa si mi pago no se acredita? Tu pedido queda pendiente y podés reintentar el pago desde tu cuenta. Si el problema persiste, escribinos por WhatsApp o a {{mailAtencionAlCliente}}.
          </div>
        </div>
      </div>
    </section>
  </div>

  <div *ngIf="menuselex.nombre==='Contacto'">
    <section>
      <div class="formsup">
        <div class="titulosop">
          Asunto
        </div>
        <input type="text" class="inputSup" placeholder="Tengo problemas con mi compra">
        <div class="titulosop">
          Mail
        </div>
        <input type="text" class="inputSup" placeholder="cliente@gmail.com">
        <div class="titulosop">
          Mensaje
        </div>
        <div class="intext">
          <textarea name="msj" placeholder="Escribe aquí tu mensaje…" class="textgrand" rows="20"></textarea>
        </div>
        <div class="botonera noselect">
          <div class="botton" (click)="enviarPregunta()">
            Enviar
          </div>
        </div>
      </div>
    </section>
  </div>
  <mmax-helpfootbar></mmax-helpfootbar>

  <foo-mariano-max></foo-mariano-max>
  <!-- <div class="explorer">
        <mmax-helpfootbar [mode]="'flotante'"></mmax-helpfootbar>
    </div> -->
</div>
